import { BASE_URL } from "../utils/BaseUrl"
import httpRequest from "../utils/httpsRequest";

export const AddCategories = async (payload) => {
  return await httpRequest(`${BASE_URL}/FoodCategories`, "post", payload );
}
export const EditCategories = async (payload) => {
  return await httpRequest(`${BASE_URL}/FoodCategories`, "put", payload );
}
export const DeleteCategories = async (payload) => {
  return await httpRequest(`${BASE_URL}/FoodCategories/${payload}`, "delete" );
}